import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import ExportExcelByVpsUsComponent from "../../../../components/Customer/vps_us/ExportExcelByVpsUsComponent";

const PageExportExcelByVpsUs = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ExportExcelByVpsUsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default PageExportExcelByVpsUs;